import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42",
  height: "42",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.335 6.46c.524-1.613 2.805-1.613 3.33 0l2.657 8.178a1.75 1.75 0 0 0 1.664 1.21h8.6c1.695 0 2.4 2.169 1.029 3.165l-6.958 5.055a1.75 1.75 0 0 0-.636 1.957l2.658 8.179c.524 1.612-1.322 2.953-2.693 1.956l-6.958-5.054a1.75 1.75 0 0 0-2.057 0l-6.957 5.054c-1.372.997-3.217-.344-2.693-1.956l2.657-8.18a1.75 1.75 0 0 0-.636-1.956l-6.957-5.055c-1.372-.996-.667-3.166 1.029-3.166h8.6a1.75 1.75 0 0 0 1.664-1.209z"
    }, null, -1)
  ]))]))
}
export default { render: render }